
import { BaseService } from './BaseService';
import { FileDAO } from "../DAO/FileDAO";

/**
 * FileService
 *
 * ファイルの送受信に関するサービス
 * DAOで取得したデータを操作等行い、View側に渡す。
 */
export class FileService extends BaseService {


  // PDFファイルをアップロードする
  public async downloadFileUri(id: number) {

    const dao = new FileDAO(this as BaseService);
    const ret = await dao.downloadFileUri(id);

    return ret;

  }


}
